export default "__VITE_ASSET__skZb7MxJ__"